import React from "react";
import img1 from "./../../images/home_img1.jpeg";
import img2 from "./../../images/home_img2.jpeg";
import { FaTwitter } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaGoogle } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";

import "./styles.css";
const HomePageContent = () => {
  return (
    <div>
      <section className="banner">
        <div className="banner__strapline background--theme text--purple-strong">
          <h1 className="banner__strapline-header banner__strapline-header--bigger editable">
            Best Personal Finance Software
          </h1>

          <div
            className="banner__strapline-content editable"
            data-cms-index="1"
            data-cms-source="/_pages/index.html"
          >
            <p>Forge your own financial path – we'll provide the tools.</p>
          </div>
        </div>

        <img className="hero-img" src={img1} alt="finance-banner" />
      </section>

      <section className="reflect-live-see">
        <div className="section-body">
          <h2 className="font--normal text--purple-light">
            Meet the features that make Budgetify unique
          </h2>
          <img className="hero-img" src={img2} alt="showcase-img" />
        </div>
      </section>
      <section className="your-path section--padding-more background--theme">
        <h2 className="text--green-medium editable">
          Be productive with your money, your way
        </h2>

        <div className="section-body">
          <div className="your-path__row">
            <div
              className="your-path__text editable"
              data-cms-index="1"
              data-cms-source="/_includes/your_path.html"
            >
              <h3 className="text--purple-light text--align-left font--normal">
                Track Your Spending, Become Independent.
              </h3>
              <p>
                In growing economic turmoil, we saw the need to practice
                financial literacy through the use of our web application. All
                members in the group will benefit from this project, as well as
                people who need financial budgeting. Today, the most common
                expense tracking application consists of paid tiers.
              </p>
              <p>
                In most of these other applications, users must pay extra costs
                to access the most useful functionalities; they end up spending
                more money than they intend to. Therefore, we want to create a
                free application, where users can use all features without
                having to pay additional costs. Our application’s targeted
                audience are individuals who require a method to accurately and
                easily track their expenses.
              </p>
              <p>
                This application will be especially useful to individuals who
                are starting to become financially responsible. From a business
                perspective, a web application is cross-platform, while a mobile
                application is only for phones. Our application will allow users
                to track their finances and monitor their spending over time.
                Our application focuses on user friendliness and usability as
                our main criteria.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section section--padding-more">
        <div className="section-body">
          <div className="features-section__heading">
            <h2 className="text--blue-medium editable">
              We Care Because You Matter
            </h2>

            <div className="editable">
              <p>
                We're a team of talented and passionate people who are committed
                in providing an exceptional experience to our users. We will
                work hard to deliver the best online personal budgeting
                software.
              </p>
            </div>
          </div>

          <div className="features-grid">
            <div className="features-grid__item">
              <h3 className="text--blue-medium editable">
                <i>Security</i>
                <br />
                Keeping your data safe and secure.
              </h3>

              <p className="editable">
                Your data is safe with us. It's encrypted in transit and at
                rest, and you're not required to share personally-identifying
                information with us.
              </p>
            </div>

            <div className="features-grid__item">
              <h3 className="text--grey-dark editable">
                <i>Tagging System</i>
                <br />
                Understanding where you came from.
              </h3>

              <p className="editable">
                The tagging allows you to organize your transactions into
                categories and subcategories. This allows you to see where your
                money is going and how much you are spending on each category.
              </p>
            </div>

            <div className="features-grid__item">
              <h3 className="text--red-medium editable">
                <i>Clear and Concise</i>
                <br />
                Simple and Clean
              </h3>

              <p className="editable">
                It is easy to navigate and use our application.
              </p>
            </div>

            <div className="features-grid__item">
              <h3 className="text--purple-light editable">
                <i>Transaction History</i>
                <br />
                Connected to Firebase
              </h3>

              <p className="editable">
                Use Budgetify from anywhere, no software to install. With online
                personal finance of listed transactions at your finger tips.
              </p>
            </div>

            <div className="features-grid__item">
              <h3 className="text--purple-medium editable">
                <i>Calendar</i>
                <br />
                Monthly Calendar
              </h3>

              <p className="editable">
                The monthly calendar feature is a way to separate us from the
                competition. It's a great way to see your upcoming bills and
                transactions.
              </p>
            </div>

            <div className="features-grid__item">
              <h3 className="text--green-dark editable">
                <i>No Ads</i>
                <br />
                No advertisements. Ever.
              </h3>

              <p className="editable">
                Some free budgeting apps advertise to you, making you their
                product. The experience is about you and your money, you will
                not be sold other products along the way.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section section--padding-more background--theme">
        <div className="section-body">
          <h2
            className="text--purple-strong editable"
            data-cms-index="25"
            data-cms-source="/_pages/index.html"
          >
            Ready to take control?
          </h2>
          <p
            className="editable"
            data-cms-index="28"
            data-cms-source="/_pages/index.html"
          >
            Click on Budget or Transaction Tab to get started.
          </p>
        </div>
      </section>

      <footer className="container background-black">
        <div className="container text-center text-md-start mt-5">
          <div className="row mt-3">
            <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
              <p className="text-uppercase fw-bold">Seneca College</p>
              <hr className="mb-4 mt-0 d-inline-block mx-auto" />
              <p>Computer Programming and Analysis</p>
            </div>

            <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
              <div className="me-5 mb-4">
                <span>Get connected with us on social networks:</span>
              </div>
            </div>

            <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
              <div className="text-center p-3 text-white background-black">
                © 2022: Budgetify
              </div>
              <div>
                <a
                  href="https://www.facebook.com/senecacollege/"
                  className="text-white me-4"
                >
                  <FaFacebook />
                  Facebook
                  <br />
                </a>
                <a
                  href="https://twitter.com/senecacollege/"
                  className="text-white me-4"
                >
                  <FaTwitter />
                  Twitter
                  <br />
                </a>
                <a
                  href="https://www.senecacollege.ca/home.html"
                  className="text-white me-4"
                >
                  <FaGoogle />
                  Google
                  <br />
                </a>
                <a
                  href="https://www.github.com/ycechungAI"
                  className="text-white me-4"
                >
                  <FaGithub />
                  Github
                  <br />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <section className="footer background--purple-dark">
        <div className="footer__strip clearfix">
          <span className="footer__copyright">
            © Budgetify Team. All rights reserved
          </span>
        </div>
      </section>
    </div>
  );
};

export default HomePageContent;
